import { ChangeDetectionStrategy, Component, OnInit, signal, inject } from '@angular/core';
import { IFileModel, IPopupModelV2, ModalChild } from '@mwe/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'mwe-media-preview',
  templateUrl: './media-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ModalComponent],
  standalone: true,
})
export class MediaPreviewComponent implements OnInit, ModalChild {
  popupModel = signal<IPopupModelV2>(null);

  private activeModal = inject(NgbActiveModal);
  private domSanitizer = inject(DomSanitizer);

  // is being passed by popupService
  loadedData: IFileModel;
  safeUrl = signal<SafeUrl>(undefined);

  ngOnInit() {
    // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
    this.safeUrl.set(this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.loadedData.base64}`));
  }

  closePopup(): void {
    this.activeModal.close('OK');
  }
}
